import React, {PureComponent} from "react";
import {connect} from "react-redux";
import classnames from "classnames";
import PropTypes from "prop-types";
import Loader from "../../common/Loader";
import {
  productSelector,
  conditionSelector,
  designsSelector,
  sidesSelector,
  onPlatformSelector
} from "../selectors";
import {applyConditionToSides} from "../AC/apply-condition-to-sides";
import {changeSide} from "../AC/change-side";
import withErrorBoundary from "../decorators/withErrorBoundary";
import {getFormattedBasicDependentPriceMap} from "../services/lib/get-price-from-scheme";
import hasDesign from "../services/lib/has-design";
import priceFormat from "../services/lib/price-format";
import { shortCurrency } from "../../../utils/currency";

class SideControl extends PureComponent {
  static propTypes = {
    product: PropTypes.object,
    condition: PropTypes.object,
    sides: PropTypes.object,
    designs: PropTypes.object,
    changeSide: PropTypes.func,
    applyConditionToSides: PropTypes.func,
    onPlatform: PropTypes.string
  };
  componentDidMount() {
    this.props.applyConditionToSides();
  }
  componentDidUpdate(prevProps) {
    const {condition: prevCondition} = prevProps;
    const {condition: nextCondition} = this.props;
    // disable update canvas when change design
    if (
      JSON.stringify({...prevCondition, design: ``}) ===
      JSON.stringify({...nextCondition, design: ``})
    ) {
      return;
    }
    this.props.applyConditionToSides();
  }
  changeSide = (side) => () => {
    return this.props.changeSide(side);
  };
  getPriceLabelForSide(side) {
    const {
      product: {
        meta: {designs, price_data: priceData}
      },
      designs: designData,
      condition: {variants},
      onPlatform,
      currency
    } = this.props;

    const getIndexOfDesignBySide = (metaDesigns, sideParam) => {
      return metaDesigns.reduce(
        (acc, item, i) => (item.side === sideParam ? i : acc),
        0
      );
    };
    const indexOfDesign = getIndexOfDesignBySide(designs, side);
    const sideHasDesign = hasDesign(designData[indexOfDesign].design);

    let price = null;

    const isMainSide =
      indexOfDesign === 0 && !designs[indexOfDesign].additional;
    const isMainDoubleSide =
      indexOfDesign === 1 && !designs[indexOfDesign].additional;
    const isAdditionalDesign = !!designs[indexOfDesign].additional;

    if (priceData.pricing_scheme === `basic_variant_dependent`) {
      const priceMap = getFormattedBasicDependentPriceMap(
        priceData.variant_prices
      );
      const dependent = Object.keys(priceData.variant_prices[0])[0];
      const priceMapForVariant = priceMap[variants[dependent]];

      if (isMainSide) {
        price = priceMapForVariant[0];
      } else if (isMainDoubleSide) {
        price = priceMapForVariant[1] || 0;
      } else if (isAdditionalDesign) {
        price = priceMapForVariant[2] || 0;
      } else {
        price = 0;
      }
    } else if (priceData.pricing_scheme === `basic`) {
      if (isMainSide) {
        price = priceData.base_price;
      } else if (isMainDoubleSide) {
        price = priceData.double_side_adjustment || 0;
      } else if (isAdditionalDesign) {
        price = priceData.additional_design_adjustment || 0;
      } else {
        price = 0;
      }
    }

    return (
      (price || price === 0) && (
        <span
          className={classnames(`side__price-label`, {
            "side__price-label_has-design": sideHasDesign,
            "side__price-label_vtb": onPlatform === `vtb`
          })}
        >
          {!isMainSide ? `+${priceFormat(price)}` : priceFormat(price)}
          {shortCurrency(currency, price)}
        </span>
      )
    );
  }

  render() {
    const {
      product: {
        meta: {designs, price_data: priceData}
      },
      condition: {side: activeSide},
      sides
    } = this.props;
    if (!sides) {
      return void 0;
    }
    const {loading, loaded, assets} = sides;
    return (
      designs.length > 1 && (
        <div className={`sides${loading && !loaded ? ` sides_loading` : ``}`}>
          {designs.map((design) => {
            const {side, name, translated_name: translatedName} = design;
            return (
              <div
                key={name}
                onClick={this.changeSide(side)}
                className={`side sides__item${
                  side === activeSide ? ` side_active` : ``
                }`}
              >
                {loading && !loaded && <Loader mod="small" />}
                {loaded && (
                  <React.Fragment>
                    <img loading="lazy"
                      src={
                        assets[side] &&
                        (assets[side].blank || assets[side].background)
                      }
                      alt={translatedName}
                      className="side__img"
                    />
                    {priceData.pricing_scheme === `basic_variant_dependent` ||
                    priceData.pricing_scheme === `basic`
                      ? this.getPriceLabelForSide(side)
                      : null}
                  </React.Fragment>
                )}
              </div>
            );
          })}
        </div>
      )
    );
  }
}

export default connect(
  (state) => ({
    product: productSelector(state),
    designs: designsSelector(state),
    condition: conditionSelector(state),
    sides: sidesSelector(state),
    onPlatform: onPlatformSelector(state),
    currency: state.currency
  }),
  {
    changeSide,
    applyConditionToSides
  }
)(withErrorBoundary(SideControl));
